import { CheckIcon, ClockIcon } from 'lucide-react';
import { APPROVAL_STAGES, stageIndex } from '../data/approvalWorkflow';

interface ApprovalTimelineProps {
  currentStageId: string;
  active: boolean;
}

export function ApprovalTimeline({ currentStageId, active }: ApprovalTimelineProps) {
  const currentIndex = active ? stageIndex(currentStageId) : -1;

  return (
    <ol className="approval-timeline">
      {APPROVAL_STAGES.map((stage, index) => {
        const state =
        currentIndex < 0 ?
        'upcoming' :
        index < currentIndex ?
        'done' :
        index === currentIndex ?
        'current' :
        'upcoming';
        return (
          <li className={`approval-item approval-item--${state}`} key={stage.id}>
            <span className="approval-dot" aria-hidden="true">
              {state === 'done' ?
              <CheckIcon size={13} /> :
              state === 'current' ?
              <ClockIcon size={13} /> :

              index + 1
              }
            </span>
            <div className="approval-body">
              <div className="approval-head">
                <h3 className="approval-label">{stage.label}</h3>
                <span className="approval-timing">{stage.timing}</span>
              </div>
              <p className="approval-detail">{stage.detail}</p>
              {stage.outcomes ?
              <ul className="approval-outcomes">
                  {stage.outcomes.map((outcome) =>
                <li key={outcome}>{outcome}</li>
                )}
                </ul> :
              null}
              {state === 'current' ?
              <span className="badge badge--red" style={{ marginTop: 6 }}>
                  Currently here
                </span> :
              null}
            </div>
          </li>);

      })}
    </ol>);

}